import {Injectable, OnDestroy} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {tenantSelector} from '../../store/samoobsluga/samoobsluga.selectors';

@Injectable({
  providedIn: 'root'
})
export class TenantService implements OnDestroy {

  private tenantSubscription
  private tenant!: string

  constructor(private store: Store) {
    this.tenantSubscription = this.store.pipe(select(tenantSelector)).subscribe(tenant => {
      this.tenant = tenant
    })
  }

  isTenantCC(): boolean {
    return this.tenant === 'CC'
  }

  isTenantPAK(): boolean {
    return this.tenant === 'PAK'
  }

  isTenantKN(): boolean {
    return this.tenant === 'CLIENT'
  }

  ngOnDestroy(): void {
    this.tenantSubscription?.unsubscribe()
  }
}
